<h2 mat-dialog-title class="treeslo-modal-header">
    <span class="treeslo-modal-header__title">{{ (isMultiStepMode ? 'stores.forms.titles.CompleteStoreConfiguration' :
        'stores.forms.titles.Update Store') | translate }}</span>
    @if (canCloseModal()) {
    <button type="button" mat-icon-button class="treeslo-modal-header__close" (click)="onCloseModal()"
        [attr.aria-label]="'common.close' | translate">
        <mat-icon>close</mat-icon>
    </button>
    }
</h2>

<mat-dialog-content class="store-update-dialog-content store-update-dialog-content--compact"
    style="max-height: none; overflow-y: auto;">
    <ng-container *ngIf="!isMultiStepMode; else multiStepStepper">
        <form [formGroup]="form">
            <div class="row ">
                <div class="col-12 mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{'stores.forms.fields.name.label' | translate}}</mat-label>
                        <input type="text" matInput required id="name" formControlName="name" />
                    </mat-form-field>
                </div>
                <div class="col-12 mb-3">
                    <mat-checkbox formControlName="hasAutoRemove" class="m-t-16">
                        <span class="auto-remove-label-with-info">
                            {{ 'stores.forms.fields.hasAutoRemove.label' | translate }}
                            <i-tabler name="info-circle" class="icon-16 auto-remove-info-icon"
                                [matTooltip]="'stores.forms.fields.hasAutoRemove.tooltip' | translate"
                                matTooltipPosition="above"
                                (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                (click)="$event.preventDefault(); $event.stopPropagation()"></i-tabler>
                        </span>
                    </mat-checkbox>
                </div>
            </div>
            <div class="mt-3 d-flex justify-content-end gap-3">
                <button style="width: 10rem;" mat-stroked-button mat-dialog-close>
                    {{'stores.forms.actions.Cancel' | translate}}
                </button>
                <button style="width: 10rem;" mat-flat-button (click)="submitUpdate()"
                    [disabled]="!form.valid || isStoreFormCached">
                    {{'stores.forms.actions.Update' | translate}}
                </button>
            </div>
        </form>
    </ng-container>

    <ng-template #multiStepStepper>
        <div class="linking-message-container d-flex align-items-center gap-2">
            <p class="linking-message m-0">
                {{ 'stores.forms.messages.linkedStepperInfo' | translate }}
            </p>
        </div>

        <mat-horizontal-stepper #stepper>
            @if(showStoreStep) {
            <mat-step [stepControl]="form">
                <ng-template matStepLabel>
                    <span class="step-icon-label step-icon-label--store">
                        <i-tabler name="pencil" class="icon-18"></i-tabler>
                    </span>
                </ng-template>
                <div class="step-layout step-layout--vertical">
                    <div class="step-info step-info--top step-info--with-popover">
                        <app-popover #storeDetailsPopover trigger="click"
                            panelClass="store-help-popover-panel app-popover-panel--compact"
                            [positions]="popoverPositions" [bodyComponent]="StoreDetailsHelpPopoverComponent">
                            <h4 class="step-info-title-with-icon">
                                {{ 'stores.forms.steps.storeDetails.title' | translate }}
                                <i-tabler name="info-circle" class="icon-16 step-info-icon"></i-tabler>
                            </h4>
                        </app-popover>
                    </div>
                    <div class="step-form">
                        <div class="step-subtitle">Store</div>
                        <form [formGroup]="form" class="mt-1">
                            <div class="row ">
                                <div class="col-12 mb-3">
                                    <mat-form-field data-tour="afterLinkingStore-storeName" appearance="outline"
                                        class="w-100">
                                        <mat-label>{{'stores.forms.fields.name.label' | translate}}</mat-label>
                                        <input type="text" matInput required id="name" formControlName="name" />
                                    </mat-form-field>
                                </div>
                                <div class="col-12 mb-3">
                                    <mat-checkbox data-tour="afterLinkingStore-autoRemove"
                                        formControlName="hasAutoRemove" class="m-t-16">
                                        <span class="auto-remove-label-with-info">
                                            {{ 'stores.forms.fields.hasAutoRemove.label' | translate }}
                                            <i-tabler name="info-circle" class="icon-16 auto-remove-info-icon"
                                                [matTooltip]="'stores.forms.fields.hasAutoRemove.tooltip' | translate"
                                                matTooltipPosition="above"
                                                (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                                (click)="$event.preventDefault(); $event.stopPropagation()"></i-tabler>
                                        </span>
                                    </mat-checkbox>
                                </div>
                            </div>
                        </form>
                        <div class="mt-3 step-form-footer">
                            <button data-tour="afterLinkingStore-submitStoreStep" mat-flat-button color="accent"
                                type="button" (click)="submitStoreStep(stepper)" [disabled]="!form.valid || isStoreFormCached">
                                {{'stores.forms.actions.Submit' | translate}}
                            </button>
                            <div class="step-footer-nav d-flex justify-content-end gap-3 mt-3">
                                <button mat-button color="primary" type="button"
                                    data-tour="afterLinkingStore-nextMultipartStep"
                                    (click)="onNextFromStoreStep(stepper)"
                                    [attr.aria-label]="'stores.forms.actions.Next' | translate">
                                    <i-tabler name="arrow-right" class="icon-18"></i-tabler>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-step>
            }

            <mat-step *ngIf="enableDeliveryAddressStep" [stepControl]="deliveryForm">
                <ng-template matStepLabel>
                    <span class="step-icon-label step-icon-label--delivery">
                        <i-tabler name="map-pin" class="icon-18"></i-tabler>
                    </span>
                </ng-template>
                <div class="step-layout step-layout--vertical">
                    <div class="step-info step-info--top step-info--with-popover">
                        <app-popover #deliveryPopover trigger="click"
                            panelClass="store-help-popover-panel app-popover-panel--compact"
                            [positions]="popoverPositions" [bodyComponent]="StoreDeliveryHelpPopoverComponent">
                            <h4 class="step-info-title-with-icon">
                                {{ 'stores.forms.steps.delivery.title' | translate }}
                                <i-tabler name="info-circle" class="icon-16 step-info-icon"></i-tabler>
                            </h4>
                        </app-popover>
                    </div>
                    <div class="step-form">
                        <div class="step-subtitle mb-3">
                            {{ 'stores.forms.fields.deliveryInfoTitle.label' | translate }}
                        </div>
                        <form [formGroup]="deliveryForm" class="mt-1">
                            <div class="row ">
                                <div class="col-12 mb-3">
                                    <mat-form-field data-tour="afterStoreLinkingAddDelivery-city" appearance="outline"
                                        class="w-100">
                                        <mat-label>{{ 'stores.forms.fields.deliveryCity.label' | translate
                                            }}</mat-label>
                                        <input type="text" matInput required formControlName="city" />
                                    </mat-form-field>
                                </div>
                                <div class="col-12 mb-3">
                                    <mat-form-field data-tour="afterStoreLinkingAddDelivery-state" appearance="outline"
                                        class="w-100">
                                        <mat-label>{{ 'stores.forms.fields.deliveryState.label' | translate
                                            }}</mat-label>
                                        <input type="text" matInput required formControlName="state" />
                                    </mat-form-field>
                                </div>
                                <div class="col-12 mb-3">
                                    <mat-form-field data-tour="afterStoreLinkingAddDelivery-postalCode"
                                        appearance="outline" class="w-100">
                                        <mat-label>{{ 'stores.forms.fields.deliveryPostalCode.label' | translate
                                            }}</mat-label>
                                        <input type="text" matInput required formControlName="postalCode" />
                                    </mat-form-field>
                                </div>
                            </div>
                        </form>
                        <div class="mt-3 step-form-footer">
                            <button data-tour="afterStoreLinkingAddDelivery-submitDelivery" mat-flat-button
                                color="accent" type="button" (click)="submitDeliveryStep()"
                                [disabled]="!deliveryForm.valid || isDeliveryFormCached">
                                {{'stores.forms.actions.Submit' | translate}}
                            </button>
                            <div class="step-footer-nav d-flex gap-3 mt-3"
                                [ngClass]="showStoreStep ? 'justify-content-between' : 'justify-content-end'">
                                <button *ngIf="showStoreStep" mat-button type="button" (click)="stepper.previous()"
                                    [attr.aria-label]="'stores.forms.actions.Back' | translate">
                                    <i-tabler name="arrow-left" class="icon-18"></i-tabler>
                                </button>
                                <button data-tour="afterStoreLinkingAddDelivery-nextStep" mat-button color="primary"
                                    type="button" (click)="onNextFromDeliveryStep(stepper)"
                                    [disabled]="!deliverySubmitted"
                                    [attr.aria-label]="'stores.forms.actions.Next' | translate">
                                    <i-tabler name="arrow-right" class="icon-18"></i-tabler>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-step>

            <mat-step [stepControl]="thresholdForm">
                <ng-template matStepLabel>
                    <span class="step-icon-label step-icon-label--threshold ">
                        <i-tabler name="gauge" class="icon-18"></i-tabler>
                    </span>
                </ng-template>
                <div class="step-layout step-layout--vertical">
                    <div class="step-info step-info--top step-info--with-popover">
                        <app-popover #thresholdPopover trigger="click"
                            panelClass="store-help-popover-panel app-popover-panel--compact"
                            [positions]="popoverPositions" [bodyComponent]="StoreThresholdHelpPopoverComponent">
                            <h4 class="step-info-title-with-icon">
                                {{ 'stores.forms.steps.threshold.title' | translate }}
                                <i-tabler name="info-circle" class="icon-16 step-info-icon"></i-tabler>
                            </h4>
                        </app-popover>
                    </div>
                    <div class="step-form threshold-step-form">
                        <form [formGroup]="thresholdForm" class="mt-1 threshold-step-form__form"
                            data-tour="afterStoreLinkingAddTreshold-thresholdForm">
                            <div class="threshold-table">
                                <div class="threshold-form-row threshold-header-row">
                                    <div class="threshold-claim-type-label">
                                        {{ 'stores.forms.fields.claimType.label' | translate }}
                                    </div>
                                    <div class="threshold-header-cell">
                                        <span class="threshold-header-title">
                                            {{ 'stores.forms.fields.thresholdAmount.label' | translate }}
                                            <i-tabler name="help-circle"
                                                class="icon-16 threshold-tooltip-icon"
                                                matTooltip="{{ 'stores.forms.fields.thresholdAmountTooltip' | translate }}"
                                                matTooltipPosition="above" matTooltipClass="threshold-tooltip"></i-tabler>
                                        </span>
                                    </div>
                                    <div class="threshold-header-cell">
                                        <span class="threshold-header-title">
                                            {{ 'stores.forms.fields.thresholdPercentage.label' | translate }}
                                            <i-tabler name="help-circle"
                                                class="icon-16 threshold-tooltip-icon"
                                                matTooltip="{{ 'stores.forms.fields.thresholdPercentageTooltip' | translate }}"
                                                matTooltipPosition="above" matTooltipClass="threshold-tooltip"></i-tabler>
                                        </span>
                                    </div>
                                </div>
                                <ng-container *ngIf="claimTypesForProvider.length; else noThresholds">
                                    <div class="threshold-grid-body pe-2">
                                        <ng-container *ngFor="let claimType of claimTypesForProvider">
                                            <div [formGroupName]="claimType.value" class="threshold-form-row">
                                                <div class="threshold-claim-type-label">
                                                    {{ "claimsTypes." + claimType.value | translate }}
                                                </div>
                                                <div class="threshold-input-with-prefix">
                                                    <span class="threshold-input-prefix" aria-hidden="true">$</span>
                                                    <mat-form-field appearance="outline"
                                                        class="w-100 threshold-amount-field" subscriptSizing="dynamic">
                                                        <input type="number" matInput required
                                                            placeholder="{{ 'stores.forms.fields.thresholdAmount.label' | translate }}"
                                                            formControlName="thresholdAmount" />
                                                    </mat-form-field>
                                                </div>
                                                <div class="threshold-input-with-prefix">
                                                    <span class="threshold-input-prefix" aria-hidden="true">%</span>
                                                    <mat-form-field appearance="outline"
                                                        class="w-100 threshold-percentage-field"
                                                        subscriptSizing="dynamic">
                                                        <input type="number" matInput required
                                                            placeholder="{{ 'stores.forms.fields.thresholdPercentage.label' | translate }}"
                                                            formControlName="thresholdPercentage" />
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </ng-container>
                            </div>
                            <ng-template #noThresholds>
                                <div class="col-12 mb-3">
                                    <p>{{ 'stores.forms.steps.threshold.noThresholds' | translate }}</p>
                                </div>
                            </ng-template>
                        </form>
                        <div class="step-form-footer">
                            <button data-tour="afterStoreLinkingAddTreshold-submitThreshold" mat-flat-button
                                color="accent" type="button" (click)="submitThresholdStep()"
                                [disabled]="!thresholdForm.valid || isThresholdFormCached">
                                {{'stores.forms.actions.Submit' | translate}}
                            </button>
                            <div class="step-footer-nav d-flex justify-content-start gap-3 mt-3">
                                <button *ngIf="hasPreviousStepForThreshold" mat-button type="button"
                                    (click)="stepper.previous()"
                                    [attr.aria-label]="'stores.forms.actions.Back' | translate">
                                    <i-tabler name="arrow-left" class="icon-18"></i-tabler>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-step>
        </mat-horizontal-stepper>
    </ng-template>
</mat-dialog-content>